/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import gql from 'graphql-tag';
import { ValidationErrorFieldsFragmentDoc } from '../../../graphql/fragments/ValidationErrorFields.generated';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LogInCustomerSuccessfulLoginFieldsFragment = {
  readonly __typename?: 'LoginSuccess';
  readonly csrf: string;
};

export type LogInCustomerInvalidCredentialsFieldsFragment = {
  readonly __typename?: 'InvalidCredentials';
  readonly message: string;
  readonly status: number;
};

export type LogInCustomerMutationVariables = Types.Exact<{
  input: Types.LoginInput;
}>;

export type LogInCustomerMutation = {
  readonly __typename?: 'Mutation';
  readonly login:
    | { readonly __typename: 'AccountLocked' }
    | {
        readonly __typename: 'InvalidCredentials';
        readonly message: string;
        readonly status: number;
      }
    | { readonly __typename: 'LoginSuccess'; readonly csrf: string }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export const LogInCustomerSuccessfulLoginFieldsFragmentDoc = gql`
  fragment LogInCustomerSuccessfulLoginFields on LoginSuccess {
    csrf
  }
`;
export const LogInCustomerInvalidCredentialsFieldsFragmentDoc = gql`
  fragment LogInCustomerInvalidCredentialsFields on InvalidCredentials {
    message
    status
  }
`;
export const LogInCustomerDocument = gql`
  mutation LogInCustomer($input: LoginInput!) {
    login(input: $input) {
      __typename
      ...LogInCustomerSuccessfulLoginFields
      ...LogInCustomerInvalidCredentialsFields
      ...ValidationErrorFields
    }
  }
  ${LogInCustomerSuccessfulLoginFieldsFragmentDoc}
  ${LogInCustomerInvalidCredentialsFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useLogInCustomerMutation() {
  return Urql.useMutation<
    LogInCustomerMutation,
    LogInCustomerMutationVariables
  >(LogInCustomerDocument);
}
